import { GetStartedContainer } from './style'
import GetStartedHero from './GetStartedHero'
import GetStartedSteps from './GetStartedSteps'

function GetStarted() {
  return (
    <GetStartedContainer>
      <GetStartedHero />
      <GetStartedSteps />
    </GetStartedContainer>
  )
}

export default GetStarted
